/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemoizedFn } from 'ahooks';
import React, { useMemo } from 'react';

interface ContentValue {
  text: string;
}

interface MsgTextProps<T extends ContentValue> {
  contentValue: T;
  actions: Array<{
    triggerFieldKeys: Array<keyof T>;
    handleClick: (fieldKey: keyof T) => void;
  }>;
}

/**
 * 系统消息文本组件
 * @param props
 * @returns
 */
export const MsgText = <_, T extends ContentValue>(props: MsgTextProps<T>) => {
  const { contentValue, actions } = props;

  const onSpanClick = useMemoizedFn((key: keyof T) => {
    actions.forEach(action => {
      if (action.triggerFieldKeys.includes(key)) {
        action.handleClick(key);
      }
    });
  });
  const elements = useMemo(() => {
    const parts = contentValue.text.split(/({{.*?}})/);
    return parts.map((part, index) => {
      const match = part.match(/\{\{(.+?)\}\}/);
      if (match) {
        const key = match[1];
        const value = (contentValue as any)[key];
        if (value) {
          return (
            <span
              key={index}
              className="text-[#525252] cursor-pointer underline"
              onClick={() => {
                onSpanClick(key as keyof T);
              }}
            >
              {value}
            </span>
          );
        }
      }
      return part;
    });
  }, [contentValue, onSpanClick]);
  return <React.Fragment>{elements}</React.Fragment>;
};
